import { useState } from "react";
import { Landmark, Loader2, X, ArrowRight } from "lucide-react";
import { useConnectPayout, startOnboarding } from "@/components/enhancer/ConnectPayoutCard";
import { money } from "@/lib/format";

// Slim, dashboard-wide prompt for enhancers who haven't enabled payouts —
// emphasised when they already have earnings waiting so nothing sits unpaid.
export default function ConnectNudge({ onGoToEarnings }) {
  const { ready, pending, unpaid, loading } = useConnectPayout();
  const [busy, setBusy] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (loading || ready || dismissed) return null; // hidden once payouts are enabled

  const hasWaiting = unpaid > 0;
  return (
    <div data-testid="connect-nudge"
      className={`mb-6 rounded-2xl px-5 py-4 flex items-center justify-between gap-4 flex-wrap border ${hasWaiting ? "bg-[#D98E73]/[0.1] border-[#D98E73]/40" : "bg-[#635BFF]/[0.06] border-[#635BFF]/25"}`}>
      <div className="flex items-start gap-3">
        <Landmark size={20} className={hasWaiting ? "text-[#B5794E] mt-0.5" : "text-[#635BFF] mt-0.5"} />
        <div>
          <p className="text-sm font-semibold text-[#1A242B]">
            {hasWaiting ? `You have ${money(unpaid)} in earnings waiting for payout` : "Set up payouts to get paid"}
          </p>
          <p className="text-xs text-[#4A5D6B] mt-0.5">
            {pending
              ? "Stripe just needs a few more details before payouts can be released."
              : hasWaiting
                ? "Connect a payout account so your earnings reach your bank instead of sitting unpaid."
                : "Connect a bank account securely via Stripe so your future earnings can be paid out."}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button onClick={() => startOnboarding(setBusy)} disabled={busy} data-testid="connect-nudge-cta" className="eyw-btn !py-2 text-sm flex items-center gap-1.5">
          {busy ? <Loader2 className="animate-spin" size={14} /> : <Landmark size={14} />} {pending ? "Finish setup" : "Set up payouts"}
        </button>
        {onGoToEarnings && (
          <button onClick={onGoToEarnings} data-testid="connect-nudge-details" className="text-sm text-[#144F75] flex items-center gap-1 hover:underline">Details <ArrowRight size={14} /></button>
        )}
        <button onClick={() => setDismissed(true)} data-testid="connect-nudge-dismiss" className="text-[#8FA89B] hover:text-[#4A5D6B] ml-1"><X size={16} /></button>
      </div>
    </div>
  );
}
